import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function MetaTimeTracking() {
    const location = useLocation();

    const timers = useRef([]);
    const startTime = useRef(Date.now());

    useEffect(() => {
        // Não rastrear dashboard e subrotas
        if (location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/Dashboard")) {
            console.log("Não rastreando dashboard e subrotas");
            return;
        }
        const enviarEvento = (nome, tempo) => {
            if (typeof window.fbq !== "undefined") {
                window.fbq("trackCustom", nome, {
                    pagina: location.pathname,
                    tempo_segundos: tempo,
                });
                console.log("Evento enviado:", nome);
            }
        };

        const handleSaida = () => {
            const tempo = (Date.now() - startTime.current) / 1000;
            const tempoArredondado = Math.floor(tempo);

            if (tempo < 5) {
                enviarEvento("TempoMenos5s", tempoArredondado);
            }

            if (tempo >= 5 && tempo < 30) {
                enviarEvento("TempoEntre5e30s", tempoArredondado);
            }
        };

        // Saiu do site (fechou aba, navegador ou trocou de site)
        window.addEventListener("beforeunload", handleSaida);

        // Fechou aba/minimizou/trocou aba
        const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                // executa apenas uma vez para evitar múltiplos envios
                document.removeEventListener("visibilitychange", handleVisibilityChange);

                handleSaida();
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);

        // 30s
        timers.current.push(
            setTimeout(() => {
                enviarEvento("Tempo30s", 30);
            }, 30000)
        );

        // 60s
        timers.current.push(
            setTimeout(() => {
                enviarEvento("Tempo60s", 60);
            }, 60000)
        );

        // 90s
        timers.current.push(
            setTimeout(() => {
                enviarEvento("Tempo90s", 90);
            }, 90000)
        );

        // 120s
        timers.current.push(
            setTimeout(() => {
                enviarEvento("Tempo120s", 120);
            }, 120000)
        );

        return () => {
            timers.current.forEach(clearTimeout);
            timers.current = [];

            window.removeEventListener("beforeunload", handleSaida);
        };
    }, []);

    return null;
}